/**
 * Advanced Trading — a home for sub-pages built on Boris Chickvashvili's methods.
 * Each sub-page is its own component under ./advanced/; this shell holds the title,
 * the description, and the sub-page tabs.
 */

import { useState } from 'react';
import { Box, Typography, Tabs, Tab, Chip, Paper } from '@mui/material';
import { AutoGraph, SwapVert, EmojiEvents, Storage } from '@mui/icons-material';
import TurningPoints from './advanced/TurningPoints';
import TurningPointsRace from './advanced/TurningPointsRace';
import MarketData from './advanced/MarketData';

const SUBPAGES = [
  { key: 'turning-points', label: 'Turning Points', icon: <SwapVert sx={{ fontSize: 16 }} />, component: <TurningPoints /> },
  { key: 'race', label: 'Methods Race', icon: <EmojiEvents sx={{ fontSize: 16 }} />, component: <TurningPointsRace /> },
  { key: 'data', label: 'Market Data', icon: <Storage sx={{ fontSize: 16 }} />, component: <MarketData /> },
];

export default function AdvancedTrading() {
  const [tab, setTab] = useState(0);
  return (
    <Box sx={{ p: { xs: 1.5, md: 3 } }}>
      <Paper elevation={0} sx={{
        p: { xs: 2, md: 3 }, mb: 2, borderRadius: 3, border: '1px solid', borderColor: 'divider',
        background: 'linear-gradient(135deg, rgba(168,85,247,0.10), rgba(59,130,246,0.06) 60%, transparent)',
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
          <AutoGraph sx={{ fontSize: 40, color: '#A855F7' }} />
          <Typography variant="h4" fontWeight="bold" sx={{ letterSpacing: -0.5 }}>
            Master Boris Chickvashvili's methods
          </Typography>
          <Chip label="ADVANCED" size="small" sx={{ bgcolor: '#A855F722', color: '#A855F7', fontWeight: 'bold' }} />
        </Box>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 1.5, maxWidth: 980, lineHeight: 1.7 }}>
          All the advanced sub-pages here were built on decades of experience, incorporating techniques from
          finance, quantum physics, mathematics, politics, astrology, biology, sociology and psychology.
        </Typography>
      </Paper>

      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2 }} variant="scrollable" scrollButtons="auto">
        {SUBPAGES.map(s => <Tab key={s.key} icon={s.icon} iconPosition="start" label={s.label} sx={{ minHeight: 44 }} />)}
      </Tabs>
      {SUBPAGES[tab].component}
    </Box>
  );
}
